import React, {useState,useEffect} from "react";
import { Container, Row,Col } from "react-bootstrap";
import PropTypes from 'prop-types';
import logo from './../../Styles/Logos/ComprisLogo.png';
import Image from "react-bootstrap/Image";

import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Button from "react-bootstrap/Button";

import pvBottle from './../../Styles/Logos/pvBottle.png';

import "./../../Home/assets/css/fontawesome.css";
import "./../../Home/assets/css/templatemo-finance-business.css";
import "./../../Home/assets/css/owl.css";


const HeaderController = props => {
  const [scrollY, setScrollY] = useState(0);
  let tabToggle ={
    '/Home':'nav-item',
    '/About':'nav-item',
    '/Services':'nav-item',
    '/Contact':'nav-item',
  }
  let tabColour ={
    '/Home':'#ffffff',
    '/About':'#ffffff',
    '/Services':'#ffffff',
    '/Contact':'#ffffff',
  }

  function handleTabClick(selectedTab){
    props.updateTab(selectedTab)
  }
  
  if(props.tab==='/'){
    tabToggle['/Home'] = 'nav-item active';
  }
  
  tabToggle[props.tab] = 'nav-item active';

  function logit() {
    setScrollY(window.scrollY);
  }

  useEffect(() => {
    function watchScroll() {
      window.addEventListener("scroll", logit);
    }
    watchScroll();
    return () => {
      window.removeEventListener("scroll", logit);
    };
  });

    if(scrollY>100){
      tabToggle[props.tab] = 'nav-item active';
      return (
          <>
            <header style={{position:'fixed',backgroundColor:'#343434',marginTop:'0px',top:'0px'}}> 
            
              <Navbar expand="lg"  > 
                <Container className="container">
                  <Navbar.Brand className="navbar-brand"  href="/"><h2>Wine Application Development Inc.</h2></Navbar.Brand>
                  <Navbar.Toggle aria-controls="basic-navbar-nav" />
                  <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                      <Nav.Link href="/Home" className={tabToggle['/Home']} onClick={()=>{handleTabClick('/Home')}}>Home</Nav.Link>
                      <Nav.Link href="/About" className={tabToggle['/About']} onClick={()=>{handleTabClick('/About')}}>About Us</Nav.Link>
                      <Nav.Link href="/Services" className={tabToggle['/Services']} onClick={()=>{handleTabClick('/Services')}}>Our Services</Nav.Link>
                      <Nav.Link href="/Contact" className={tabToggle['/Contact']} onClick={()=>{handleTabClick('/Contact')}}>Contact Us</Nav.Link>
                    </Nav>
                  </Navbar.Collapse>
                </Container>
              </Navbar>
            </header>
          </>
      );
    } else {
      return (
          <>
            <header style={{position:'fixed'}}> 
              <Navbar expand="lg" className="navbar navbar-expand-lg" > 
                <Container className="container">
                  <Navbar.Brand className="navbar-brand"  href="/"><h2>Wine Application Development Inc.</h2></Navbar.Brand>
                  <Navbar.Toggle aria-controls="basic-navbar-nav" />
                  <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                      <Nav.Link href="/Home" className={tabToggle['/Home']} onClick={()=>{handleTabClick('/Home')}}>Home</Nav.Link>
                      <Nav.Link href="/About" className={tabToggle['/About']} onClick={()=>{handleTabClick('/About')}}>About Us</Nav.Link>
                      <Nav.Link href="/Services" className={tabToggle['/Services']} onClick={()=>{handleTabClick('/Services')}}>Our Services</Nav.Link>
                      <Nav.Link href="/Contact" className={tabToggle['/Contact']} onClick={()=>{handleTabClick('/Contact')}}>Contact Us</Nav.Link>
                    </Nav>
                  </Navbar.Collapse>
                </Container>
              </Navbar>
            </header>
          </>
      );
    }
}
HeaderController.defaultProps = {

}
HeaderController.propTypes = {
/** State Props */
tab: PropTypes.string,
updateTab:PropTypes.func,
}

const HeaderComponent = props => {
  
    return(
      <>
      <div class="sub-header">
        <div class="container">
            <div class="row">
            <div class="col-md-8 col-xs-12">
                <ul class="left-info">
                <li><a href="#"><i class="fa fa-clock-o"></i>Willamette Valley Oregon</a></li>
                <li><a href="#"><i class="fa fa-phone"></i>503-939-5335</a></li>
                </ul>
            </div>
            <div class="col-md-4">
                <ul class="right-icons">
                <li><a href="#"><i class="fa fa-facebook"></i></a></li>
                <li><a href="#"><i class="fa fa-twitter"></i></a></li>
                <li><a href="#"><i class="fa fa-linkedin"></i></a></li>
                <li><a href="#"><i class="fa fa-behance"></i></a></li>
                </ul>
            </div>
            </div>
        </div>
      </div>
      <HeaderController tab={props.tab} updateTab={props.updateTab}/>
      </>
    );

}

HeaderComponent.defaultProps = {

}
HeaderComponent.propTypes = {
/** State Props */
tab: PropTypes.string,
updateTab:PropTypes.func,
}

export default (HeaderComponent);